/* eslint-disable */

// ** Module imports **
import React from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import moment from "moment";
import { withRouter } from "react-router";

// ** Material UI imports **
import Input, { InputLabel } from "material-ui/Input";
import { CircularProgress } from "material-ui/Progress";
import { withStyles } from "material-ui/styles";
import green from "material-ui/colors/green";
import { FormControl } from "material-ui/Form";
import MenuItem from "material-ui/Menu/MenuItem";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import Card, { CardHeader, CardContent } from "material-ui/Card";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';


// ** React plugin **
import { Row } from 'react-flexbox-grid';

// ** Actions **
import {
  launchMeteringServiceProvider,
} from "../../actions";

// ** Custom components **
// import LoadingCircle from "../commons/LoadingCircle";

// ** Constants **
import { AssetMeteringPeriodTypes } from "../../constants/AssetMeteringPeriodTypes";

const styles = theme => ({
  card: {

  },
  lastMainButton: {
    marginLeft: 0, 
    marginTop: 40,
  },
  indentedContent: {
    marginLeft: 10, 
    marginBottom: 20
  },
  subTitle: {
    marginLeft: 0
  },
  inputWithMargin: {
    marginRight: 15
  },
  inputTextFormat: {
    minWidth: 200,
    fontSize: "13px"
  },
  buttonProgress: {
    color: green[500],
    marginTop: 6,
    marginLeft: 6,
    zIndex: 1000
  },
});

class MeteringServiceManualCall extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      source: "GEMS",
      source_id: "MAREGH",
      asset: "MAREGES",
      period_number: 1,
      period_type: "hour",
      start_date: moment("2019-11-01").toDate(),
      end_date: moment("2019-11-10").toDate(),
      production_type: "Production"
    }
  }

  /*
  export interface IMeteringServiceProviderCall {
    source: string;
    source_id: string;
    asset: string;
    period_number: number;
    period_type: EPeriodType;
    production_type: EAssetType;
    start_date: Date;
    end_date: Date;
  }
  */

  handleCallMeteringServiceManual = () => {
    let meteringServiceManualCall = {
      source: this.state.source,
      source_id: this.state.source_id,
      asset: this.state.asset,
      production_type: this.state.production_type,
      period_type: this.state.period_type,
      period_number: this.state.period_number,
      start_date: this.state.start_date,
      end_date: this.state.end_date
    };
 
    this.props.launchMeteringServiceProvider(meteringServiceManualCall);
  };

  render() {
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className={classes.root}>
        <Card className={classes.card} style={{ marginTop: 40 }}>
          <CardHeader
              title={t("Metering service manual provider call")}
            />
          <CardContent>
            <Grid item xs={12}>
              <Row className={classes.subTitle}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontSize: "0.875rem"}}
                >
                  Source selection
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-source">
                    Source
                  </InputLabel>
                  <Input
                    id="adornment-source"
                    type="text"
                    value={this.state.source}
                    autoComplete="Source"
                    onChange={(event) => { this.setState({ source: event.target.value }) }}
                  />
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-source-id">
                    Source ID
                  </InputLabel>
                  <Input
                    id="adornment-source-id"
                    type="text"
                    value={this.state.source_id}
                    autoComplete="Source ID"
                    onChange={(event) => { this.setState({ source_id: event.target.value }) }}
                  />
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-asset-id">
                    Asset ID
                  </InputLabel>
                  <Input
                    id="adornment-asset-id"
                    type="text"
                    value={this.state.asset}
                    autoComplete="Asset ID"
                    onChange={(event) => { this.setState({ asset: event.target.value }) }}
                  />
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <TextField
                    style={{ fontSize: "13px", minWidth: 200, marginTop: 0 }}
                    label="Asset type"
                    id="select-asset-type"
                    select
                    value={this.state.production_type}
                    onChange={(event) => { this.setState({ production_type: event.target.value }) }}
                    margin="normal"
                  >
                    <MenuItem value="">
                      -
                    </MenuItem>
                    <MenuItem value="Production">
                      Production
                    </MenuItem>
                    <MenuItem value="Consumption">
                      Consumption
                    </MenuItem>
                  </TextField>
                </FormControl>
              </Row> 
              <Row className={classes.subTitle}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontSize: "0.875rem"}}
                >
                  Date range
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>
                <FormControl className={classes.inputWithMargin} >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      className={classes.inputTextFormat}
                      format="dd/MM/yyyy"
                      openTo={"year"}
                      id="metering-service-start-date"
                      label="Start date"
                      value={this.state.start_date}
                      onChange={(newDate) => { 
                        if(!moment(newDate).isValid() || !newDate) {
                          newDate = null;
                        }
                        
                        this.setState({ start_date: newDate });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider> 
                </FormControl>
                <FormControl className={classes.inputWithMargin}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      format="dd/MM/yyyy"
                      openTo={"year"}
                      id="metering-service-end-date"
                      label="End date"
                      value={this.state.end_date}
                      onChange={(newDate) => { 
                        if(!moment(newDate).isValid() || !newDate) {
                          newDate = null;
                        }
                        
                        this.setState({ end_date: newDate });
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </FormControl>
              </Row>
              <Row className={classes.subTitle}>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="textSecondary"
                  style={{ fontSize: "0.875rem"}}
                >
                  Asset Metering
                </Typography>
              </Row>
              <Row className={classes.indentedContent}>  
                <FormControl className={classes.inputWithMargin}>
                  <InputLabel htmlFor="adornment-period-number">
                    Period number
                  </InputLabel>
                  <Input
                    id="adornment-period-number"
                    type="text"
                    value={this.state.period_number}
                    onChange={(event) => { this.setState({ period_number: event.target.value }) }}
                  />
                </FormControl>
                <TextField
                  style={{ fontSize: "13px", width: 140 }}
                  id="select-period-type"
                  select
                  value={
                    this.state.period_type ? this.state.period_type : AssetMeteringPeriodTypes
                  }
                  onChange={(event) => { this.setState({ period_type: event.target.value }) }}
                  SelectProps={{
                    MenuProps: {
                      className: classes.menu
                    }
                  }}
                  margin="normal"
                  >
                  {AssetMeteringPeriodTypes.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Row>
              <Row className={classes.lastMainButton}>
                <Button
                  type="submit"
                  variant="raised"
                  color="primary"
                  onClick={this.handleCallMeteringServiceManual}
                  disabled={
                    !this.state.source ||
                    !this.state.source_id ||
                    !this.state.asset ||
                    !this.state.period_number ||
                    !this.state.period_type ||
                    !this.state.production_type ||
                    !this.state.start_date ||
                    !this.state.end_date ||
                    this.props.callingMeteringService
                  }
                >
                  Launch manual provider call
                </Button>
                {this.props.callingMeteringService && <CircularProgress size={24} className={classes.buttonProgress} />}
              </Row>
            </Grid>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = ({
  meteringServiceReducer
}) => {
  const { 
    callingMeteringService
  } = meteringServiceReducer;

  return { 
    callingMeteringService
  };
};

const mapDispatchToProps = {
  launchMeteringServiceProvider,
};

MeteringServiceManualCall = withStyles(styles, { name: "MeteringServiceManualCall" })(MeteringServiceManualCall);
MeteringServiceManualCall = translate("translations")(MeteringServiceManualCall);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MeteringServiceManualCall)
);



// WEBPACK FOOTER //
// ./src/components/Maintenance/MeteringServiceManualCall.js